// ABOUTME: Detail view for a custom page, rendering the configured detailLayout.
// ABOUTME: Passes nodeId from the URL to the layout renderer for node-editor widgets.

import { NodeEditorSaveStateProvider } from '../context/NodeEditorSaveStateContext';
import { CustomPage } from '../types';
import { LayoutRenderer } from './LayoutRenderer';

interface CustomPageDetailViewProps {
    page: CustomPage;
    nodeId: string;
}

export function CustomPageDetailView({ page, nodeId }: CustomPageDetailViewProps) {
    return (
        <NodeEditorSaveStateProvider>
            <LayoutRenderer
                layout={page.detailLayout}
                context={{
                    hierarchyId: page.hierarchyId,
                    nodeId,
                    objectSchemaCode: page.objectSchemaCode ?? undefined,
                    slug: page.slug,
                    filter: page.filter ?? undefined,
                }}
            />
        </NodeEditorSaveStateProvider>
    );
}
